import { render } from "./ProfileProgress.vue?vue&type=template&id=7ccd7179&scoped=true"
import script from "./ProfileProgress.vue?vue&type=script&lang=js"
export * from "./ProfileProgress.vue?vue&type=script&lang=js"

import "./ProfileProgress.vue?vue&type=style&index=0&id=7ccd7179&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\wordpress\\wp-content\\themes\\yka-theme-2022\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ccd7179"]])

export default __exports__